module.exports = __webpack_public_path__ + "static/media/kids-hand-squeezing-frosting.bf5a1427.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kids-hand-squeezing-frosting.jpg
// module id = 812
// module chunks = 0